import { LINKS } from '@fans-fund-me/shared-comm-react-cosmos/fans-fund-me/links';
import { Screen } from '@fans-fund-me/shared-comm-react-cosmos/fans-fund-me/register-account-screen';
import { useAuth } from '@fans-fund-me/shared-common-esm-authentication';
import { useVisitorData } from '@fingerprint/react';
import { useForm } from '@mantine/form';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import { checkEmailAddress } from '../../api/authentication.ts';
import { createProfile } from '../../api/profile.ts';
import { FORM_ERRORS } from '../../constants/form_errors.ts';

function RegisterAccount() {
  const auth = useAuth();
  const navigate = useNavigate();
  const { getData } = useVisitorData({ immediate: false });

  const [isLoading, setIsLoading] = useState(false);
  const form = useForm({
    mode: 'uncontrolled',
    initialValues: {
      email_address: '',
      password: '',
      confirm_password: '',
      agree_marketing: false,
    },
    validate: {
      email_address: (value) => (/^\S+@\S+$/.test(value) ? null : FORM_ERRORS.EMAIL_INVALID),
      password: (value) => (value.length < 8 ? FORM_ERRORS.PASSWORD_LENGTH_VALIDATION : null),
      confirm_password: (value, values) =>
        value !== values.password ? FORM_ERRORS.PASSWORD_CONFIRMATION_VALIDATION : null,
    },
  });

  const handleSubmit = (values: typeof form.values) => {
    setIsLoading(true);
    checkEmailAddress(values.email_address)
      .then(() => {
        getData()
          .then((fingerprint) => {
            createProfile({
              username: localStorage.getItem('ffm_register_username')?.toLowerCase(),
              email: values.email_address,
              password: values.password,
              accountType: localStorage.getItem('ffm_register_account_type'),
              displayName: localStorage.getItem('ffm_register_username')?.toLowerCase(),
              currency: localStorage.getItem('ffm_register_currency'),
              country: localStorage.getItem('ffm_register_country'),
              phoneConfirmationId: localStorage.getItem('ffm_register_phone_number_confirmation'),
              fingerprintEventId: fingerprint.event_id,
              emailProductUpdates: values.agree_marketing,
            })
              .then(() => {
                setIsLoading(false);
                auth.login({ email: values.email_address, password: values.password }).then(() => {
                  navigate(LINKS.REGISTER_PROFILE);
                });
              })
              .catch((error) => {
                setIsLoading(false);
                form.setErrors({
                  email_address: error.response.data.fields?.find(
                    (field: { fieldName: string; message: string }) => field.fieldName === 'email',
                  )?.message,
                  password: error.response.data.fields?.find(
                    (field: { fieldName: string; message: string }) => field.fieldName === 'password',
                  )?.message,
                  confirm_password: error.response.data.fields?.find(
                    (field: { fieldName: string; message: string }) => field.fieldName === 'confirm-password',
                  )?.message,
                });
              });
          })
          .catch(() => {
            form.setErrors({
              email_address: 'There was an issue creating your account. Please try again.',
            });
          });
      })
      .catch((error) => {
        setIsLoading(false);
        form.setErrors({
          email_address: error.response.data.fields?.find(
            (field: { fieldName: string; message: string }) => field.fieldName === 'email',
          )?.message,
        });
      });
  };

  return <Screen form={form} handleSubmit={handleSubmit} isLoading={isLoading} />;
}

export default RegisterAccount;
